export const buildGetTemplateTokensQueryParams = (params: {
  lobs: string[];
  is_claim_level: boolean;
  feature_specific?: string;
  sub_organization_ids?: number[];
}): string => {
  const searchParams = new URLSearchParams();
  searchParams.append('is_claim_level', params.is_claim_level.toString());

  if (params.lobs) {
    params.lobs.forEach((lob) => searchParams.append('lobs', lob));
  }
  if (params.feature_specific) {
    searchParams.append('feature_specific', params.feature_specific);
  }
  if (params.sub_organization_ids) {
    params.sub_organization_ids.forEach((id) => searchParams.append('sub_organization_ids[]', id.toString()));
  }
  return searchParams.toString();
};
